import api from '../api';

/**
 * Sets tags for a resource.
 *
 * @param {Array} tags - The array of tags to set.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const setTags = async (tags) => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/tags/set`;

  try {
    const response = await api.post(endpoint, {
      "Tags":tags
    });
    return response.data;
  } catch (error) {
    console.error('Error setting tags:', error);
    throw error;
  }
}

export default setTags;
